import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    padding: "20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  header: {
    marginBottom: "24px",
  },
  divider: {
    margin: "24px 0",
  },
  warningCard: {
    marginBottom: "32px",
    backgroundColor: tokens.colorPaletteYellowBackground2,
    border: `1px solid ${tokens.colorPaletteYellowBorder2}`,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  warningIcon: {
    color: tokens.colorPaletteYellowForeground2,
  },
  warningList: {
    margin: "8px 0 0 0",
    paddingLeft: "20px",
    "& li": {
      marginBottom: "8px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
  section: {
    marginBottom: "32px",
  },
  sectionIcon: {
    marginRight: "8px",
    verticalAlign: "middle",
  },
  sectionDescription: {
    marginTop: "8px",
    marginBottom: "16px",
    color: tokens.colorNeutralForeground2,
  },
  quickStartTable: {
    marginTop: "16px",
    "& tbody tr": {
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
      "&:last-child": {
        borderBottom: "none",
      },
    },
  },
  stepCell: {
    width: "40px",
    textAlign: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: "4px",
  },
  servicesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "16px",
    marginTop: "16px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  },
  serviceCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  serviceHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  serviceIcon: {
    color: tokens.colorBrandForeground1,
  },
  serviceContent: {
    padding: "0 16px 16px 16px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  stepsTitle: {
    marginTop: "12px",
    marginBottom: "8px",
  },
  stepsList: {
    margin: "0 0 16px 0",
    paddingLeft: "20px",
    flex: 1,
    "& li": {
      marginBottom: "6px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
  serviceInfo: {
    marginTop: "auto",
  },
  infoRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    marginBottom: "8px",
  },
  infoIcon: {
    color: tokens.colorNeutralForeground3,
    marginTop: "2px",
    flexShrink: 0,
  },
  serviceLink: {
    display: "inline-block",
    marginTop: "8px",
    marginRight: "12px",
  },
  tipsCard: {
    marginBottom: "16px",
  },
  tipsList: {
    margin: "8px 0 0 0",
    paddingLeft: "20px",
    "& li": {
      marginBottom: "6px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
  helpSection: {
    marginTop: "40px",
  },
  helpCard: {
    backgroundColor: tokens.colorNeutralBackground3,
  },
  helpList: {
    margin: "8px 0 0 0",
    paddingLeft: "20px",
    "& li": {
      marginBottom: "6px",
    },
  },
});
